import ALoaderAc from './a-loader-ac.vue';

export default ALoaderAc;
